import {styled} from '../../utils';
import {padding, borderRadius, rgba} from 'polished';
import {Footer} from '../Layout';

export default styled(Footer)(({theme}) => ({
  boxSizing: 'border-box',
  background: rgba('#F1F3F6', 0.3),
  borderBottom: '1px solid #F1F3F6',
  ...padding(20, 25),
  ...borderRadius('bottom', 3)
}));



// WEBPACK FOOTER //
// ./src/components/Card/CardFooter.tsx